import React from 'react';

export const useForceUpdate = () => {
  // https://twitter.com/dan_abramov/status/1118301474876948480
  return React.useReducer((x) => x + 1, 0)[1] as () => void;
};
